/* eslint-disable complexity */
import React from "react";
import PropTypes from "prop-types";
import iconsMap from "src/assets/iconsMap";
import getConfig from "src/analyticsProvider";
import { trackPageInteraction } from "asos-contentweb-analytics-middleware";
import { CardListItem } from "../ContentElements/CardListItem/CardListItem";

export default function ContactChannels({
  chatNow,
  channels,
  liveChatAvailable,
  showEmailButton,
}) {
  const enabledChannels = channels.filter((item) => item.enabled);
  const [emailChannel, ...otherChannels] = enabledChannels;
  const chatNowContent = chatNow[liveChatAvailable ? "online" : "offline"];

  function sendAnalytics(e) {
    const channelName = e.currentTarget.getAttribute("data-value");
    const channelsConfig = getConfig("get-in-touch-channels", {
      channelName,
    });
    trackPageInteraction(channelsConfig);
  }

  return (
    <>
      {chatNow.enabled && (
        <CardListItem
          key={chatNowContent.text}
          text={chatNowContent.text}
          link={chatNowContent?.link?.href ?? ""}
          target={chatNowContent?.link?.target ?? ""}
          icon={iconsMap(chatNowContent.iconId && chatNowContent.iconId.text)}
          onClick={(e) => sendAnalytics(e)}
          disabled={!liveChatAvailable}
          styleClass="contactList"
        />
      )}
      {emailChannel && showEmailButton && (
        <CardListItem
          key={emailChannel.text}
          link={emailChannel.link && emailChannel.link.href}
          target={(emailChannel.link && emailChannel.link.target) || null}
          text={emailChannel.text}
          icon={iconsMap(emailChannel.iconId && emailChannel.iconId.text)}
          onClick={(e) => sendAnalytics(e)}
          styleClass="contactList"
        />
      )}
      {otherChannels.map((item) => (
        <CardListItem
          key={item.text}
          link={item.link && item.link.href}
          target={(item.link && item.link.target) || null}
          text={item.text}
          icon={iconsMap(item.iconId && item.iconId.text)}
          onClick={(e) => sendAnalytics(e)}
          styleClass="contactList"
        />
      ))}
    </>
  );
}

ContactChannels.propTypes = {
  chatNow: PropTypes.object,
  channels: PropTypes.array,
  storeData: PropTypes.object,
  liveChatAvailable: PropTypes.bool.isRequired,
  showEmailButton: PropTypes.bool.isRequired,
};
